<template>
  <div id="OrderActions">
    <ActionSummaryModal />
    <ReceiveOrderModal />
    <EstimatedReceiveDateModal />
    <ScheduleDeliveryModal />
    <DeliveryDateHistoryLogsModal />
    <AddOrderToTruckModal />
    <RemoveOrderFromTruckModal />
    <TimeframeEntryModal />
    <OrderCompletionModal />
    <CancelOrderModal />
    <MessageCustomerModal />
    <LoadActivitiesModal />
    <CopyOrderModal />
    <MapModal />
    <BarcodeMapModal />
    <ImagesModal />
    <ImageUploadModal />
    <DocumentUploadModal />
    <AddNoteModal />
    <TruckOrderViewModal />
    <ConsigneeContactEntryModal />
    <ConsigneeContactSearchModal />
    <OrderAuditTrailModal />
    <CustomerNotReadyModal />
    <UpdateOrderInstructionsModal />
    <UncancelOrderModal />
    <OrderPreviewModal />
    <SetBulkOrdersWantsAsapModal />
    <AddOrderPalletsModal />
    <CreateBarcodeOrderFromHeaderNumberModal />
    <LinkInventoryToOrderModal />
  </div>
</template>
<script>
import ReceiveOrderModal from "@/components/widgets/Modals/ReceiveOrderModal";
import EstimatedReceiveDateModal from "@/components/widgets/Modals/EstimatedReceiveDateModal";
import ScheduleDeliveryModal from "@/components/widgets/Modals/ScheduleDeliveryModal";
import DeliveryDateHistoryLogsModal from "@/components/widgets/Modals/DeliveryDateHistoryLogsModal";
import OrderCompletionModal from "@/components/widgets/Modals/OrderCompletionModal";
import CancelOrderModal from "@/components/widgets/Modals/CancelOrderModal";
import UncancelOrderModal from "@/components/widgets/Modals/UncancelOrderModal";
import AddOrderToTruckModal from "@/components/widgets/Modals/AddOrderToTruckModal";
import RemoveOrderFromTruckModal from "@/components/widgets/Modals/RemoveOrderFromTruckModal";
import MessageCustomerModal from "@/components/widgets/Modals/MessageCustomerModal";
import LoadActivitiesModal from "@/components/widgets/Modals/LoadActivitiesModal";
import TimeframeEntryModal from "@/components/widgets/Modals/TimeframeEntryModal";
import CopyOrderModal from "@/components/widgets/Modals/CopyOrderModal";
import MapModal from "@/components/widgets/Modals/MapModal";
import BarcodeMapModal from "@/components/widgets/Modals/BarcodeMapModal";
import ImagesModal from "@/components/widgets/Modals/ImagesModal";
import ImageUploadModal from "@/components/widgets/Modals/ImageUploadModal";
import DocumentUploadModal from "@/components/widgets/Modals/DocumentUploadModal";
import AddNoteModal from "@/components/widgets/Modals/AddNoteModal";
import TruckOrderViewModal from "@/components/widgets/Modals/TruckOrderViewModal";
import ActionSummaryModal from "@/components/widgets/Modals/ActionSummaryModal";
import ConsigneeContactEntryModal from "@/components/widgets/Modals/ConsigneeContactEntryModal";
import ConsigneeContactSearchModal from "@/components/widgets/Modals/ConsigneeContactSearchModal";
import OrderAuditTrailModal from "@/components/widgets/Modals/OrderAuditTrailModal";
import CustomerNotReadyModal from "@/components/widgets/Modals/CustomerNotReadyModal";
import UpdateOrderInstructionsModal from "@/components/widgets/Modals/UpdateOrderInstructionsModal";
import OrderPreviewModal from "@/components/widgets/Modals/OrderPreviewModal";
import SetBulkOrdersWantsAsapModal from "@/components/widgets/Modals/SetBulkOrdersWantsAsapModal";
import AddOrderPalletsModal from "@/components/widgets/Modals/AddOrderPalletsModal";
import CreateBarcodeOrderFromHeaderNumberModal from "@/components/widgets/Modals/CreateBarcodeOrderFromHeaderNumberModal";
import LinkInventoryToOrderModal from "@/components/widgets/Modals/LinkInventoryToOrderModal";

export default {
  name: "OrderActions",
  components: {
    ReceiveOrderModal,
    EstimatedReceiveDateModal,
    ScheduleDeliveryModal,
    DeliveryDateHistoryLogsModal,
    OrderCompletionModal,
    CancelOrderModal,
    TimeframeEntryModal,
    AddOrderToTruckModal,
    RemoveOrderFromTruckModal,
    MessageCustomerModal,
    LoadActivitiesModal,
    CopyOrderModal,
    MapModal,
    BarcodeMapModal,
    ImagesModal,
    ImageUploadModal,
    DocumentUploadModal,
    AddNoteModal,
    UpdateOrderInstructionsModal,
    TruckOrderViewModal,
    ActionSummaryModal,
    ConsigneeContactEntryModal,
    ConsigneeContactSearchModal,
    OrderAuditTrailModal,
    CustomerNotReadyModal,
    UncancelOrderModal,
    OrderPreviewModal,
    SetBulkOrdersWantsAsapModal,
    AddOrderPalletsModal,
    CreateBarcodeOrderFromHeaderNumberModal,
    LinkInventoryToOrderModal
  }
};
</script>
